/* CreditNotes.tsx
    Une page affichant la gestion des avoirs
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les avoirs
    Utilise l'API correspondante pour les opérations de données
*/

import { faMoneyBillTransfer } from '@fortawesome/free-solid-svg-icons';
import { CreditNotesCrudCard } from 'features/creditNotes/components/CreditNotesCrudCard';
import PageHeader from 'layout/PageHeader';

export const CreditNotes = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faMoneyBillTransfer}
			title="Avoirs"
			subtitle="Gérez les avoirs de vos clients"
		/>
		<CreditNotesCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
